import defaultSettings from '@/settings'
import { get } from '@/api/setting'

const { showSettings, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  tagsView: true,
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  settings: {
    areas: [],
    sessions: []
  }
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  SET_SETTING: (state, { areas, sessions }) => {
    // eslint-disable-next-line no-prototype-builtins
    state.settings.areas = areas
    state.settings.sessions = sessions
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  setSetting({ commit }) {
    return new Promise((resolve, reject) => {
      get().then(response => {
        commit('SET_SETTING', response)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

